module.exports = __webpack_public_path__ + "static/img/title.36bf1439.png";